export const TICKER_CHANGE_THEME = "TICKER_CHANGE_THEME";
export const TICKER_DEFAULT_CURRENCY = "TICKER_DEFAULT_CURRENCY";
export const TICKER_LOCAL_CURRENCY_LIST = "TICKER_LOCAL_CURRENCY_LIST";
export const TICKER_GET_DATA = "TICKER_GET_DATA";
export const TICKER_L1_CHANGE_STYLE = "TICKER_L1_CHANGE_STYLE";
export const TICKER_DEFAULT_CHANGE_STYLE = "TICKER_DEFAULT_CHANGE_STYLE";
export const TICKER_DEFAULT_LOCAL_CURRENCY = "TICKER_DEFAULT_LOCAL_CURRENCY";
export const TICKER_DEFAULT_BG = 'TICKER_DEFAULT_BG';
